export default {
  public: {
    answer: `${import.meta.env.VITE_API_URL}/public/answer/`,
    events: (form_key: string): string =>
      `${import.meta.env.VITE_API_URL}/public/events?form_key=${encodeURIComponent(form_key)}`,
    form: (instance_key: string): string =>
      `${import.meta.env.VITE_API_URL}/public/form/?instance_key=${encodeURIComponent(instance_key)}`,
    entries: (instance_key: string, email: string): string =>
      `${import.meta.env.VITE_API_URL}/public/entries?instance_key=${encodeURIComponent(instance_key)}&email=${encodeURIComponent(email)}`,
    survey: (instance_key: string): string =>
      `${import.meta.env.VITE_API_URL}/public/form?instance_key=${encodeURIComponent(instance_key)}`,
  },
};
